export default "__VITE_ASSET__Bp1o6_BJ__"